import React from "react";
import { referees, connect } from "../mock";
import { SectionBanner } from "./About";
import { Quote, Linkedin } from "lucide-react";

const Referees = () => {
  return (
    <>
      {/* Referees */}
      <SectionBanner title="Referees" id="referees" />
      <section className="bg-neutral-50">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-20 space-y-8">
          {referees.map((r, i) => (
            <div
              key={i}
              className="reveal bg-white rounded-lg p-8 md:p-10 shadow-sm border border-neutral-100"
            >
              <Quote className="text-lime-400" size={32} />
              <p className="mt-4 text-neutral-600 tracking-body leading-relaxed text-[15px] italic">
                {r.quote}
              </p>
              <div className="mt-6 border-t border-neutral-100 pt-5">
                <h4 className="font-head font-bold text-neutral-800 text-lg">
                  {r.name}
                </h4>
                <p className="text-neutral-500 tracking-body text-sm">{r.title}</p>
                {r.tag && (
                  <p className="mt-1 text-lime-600 tracking-body text-xs font-medium">
                    {r.tag}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Connect */}
      <section
        id="connect"
        className="bg-lime-500 scroll-mt-20"
      >
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-24 text-center">
          <h2 className="font-head font-extrabold text-white text-4xl md:text-5xl">
            {connect.heading}
          </h2>
          <p className="mt-6 text-white/95 tracking-body leading-relaxed text-base md:text-lg">
            {connect.body}
          </p>
          <a
            href={connect.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-10 bg-white hover:bg-neutral-900 hover:text-white text-neutral-900 font-head font-semibold text-sm px-9 py-4 rounded transition-all duration-200 hover:-translate-y-0.5 shadow-sm hover:shadow-lg"
          >
            <Linkedin size={18} /> Connect on LinkedIn
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-neutral-900 text-neutral-400">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-head font-semibold text-white text-lg">
            Greta Stojanovic
          </p>
          <p className="tracking-body text-sm text-center">
            &copy; {new Date().getFullYear()} Greta Stojanovic. Data Scientist &middot; Statistician &middot; Pianist.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Referees;
